export default __webpack_public_path__ + "static/media/undereyePuffinessActive.52bf189e.svg";